import { Link } from 'react-router-dom';
import styles from './Button.module.css';

interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  href?: string;
  onClick?: () => void;
  type?: 'button' | 'submit';
  className?: string;
  [dataAttr: `data-${string}`]: string | undefined;
}

export function Button({
  children,
  variant = 'primary',
  href,
  onClick,
  type = 'button',
  className = '',
  ...rest
}: ButtonProps) {
  const classNames = `${styles.button} ${styles[variant]} ${className}`.trim();

  if (href) {
    if (href.startsWith('http')) {
      return (
        <a href={href} className={classNames} target="_blank" rel="noopener noreferrer" {...rest}>
          {children}
        </a>
      );
    }
    return (
      <Link to={href} className={classNames} onClick={onClick} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} className={classNames} onClick={onClick} {...rest}>
      {children}
    </button>
  );
}
